import { AiOutlineLoading3Quarters } from "react-icons/ai";

const SubmitButton = ({
  label = "Add",
  isLoading = false,
  onClick,
  disabled,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`w-full bg-white text-btn-warning border-2 rounded-full border-btn-warning px-6 py-4 font-semibold text-base sm:text-lg ${
        disabled ? "" : "hover:bg-btn-warning  hover:text-white"
      } transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98] transform flex justify-center items-center gap-2`}
    >
      {isLoading ? (
        <>
          <AiOutlineLoading3Quarters className="animate-spin h-5 w-5" />
          {label}...
        </>
      ) : (
        label
      )}
    </button>
  );
};

export default SubmitButton;
